const labels = { images: 'Fotos', image: 'Foto principal', image_2: 'Foto 2', image_3: 'Foto 3', videos: 'Videos', blisters: 'Presentaciones', name: 'Nombre', price: 'Precio', stock: 'Stock', seed_count: 'Cantidad de semillas' };

function messages(value, prefix = '') {
  if (typeof value === 'string') return [prefix ? `${prefix}: ${value}` : value];
  if (Array.isArray(value)) return value.flatMap(item => messages(item, prefix));
  if (!value || typeof value !== 'object') return [];
  return Object.entries(value).flatMap(([key, item]) => messages(item,
    ['detail', 'message', 'error', 'non_field_errors'].includes(key) ? prefix : (labels[key] || key)));
}

export function apiErrorMessage(error, fallback = 'No se pudo completar la operación.') {
  const status = error.response?.status;
  if (status === 401) return 'Tu sesión venció. Iniciá sesión nuevamente y volvé a intentar.';
  if (status === 403) return 'No tenés permiso para esta operación. Verificá que estés usando una cuenta administradora.';
  if (status === 413) return 'El servidor rechazó el tamaño del archivo. Usá una foto más liviana (máximo 20 MB).';
  if (status === 429) {
    const seconds = Number(error.response?.headers?.['retry-after']);
    return `Se alcanzó el límite temporal de solicitudes. ${seconds > 0 ? `Esperá ${Math.ceil(seconds / 60)} minuto(s)` : 'Esperá unos minutos'} y volvé a intentar.`;
  }
  if (status === 404) return 'El producto o recurso ya no está disponible. Actualizá la página.';
  if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' || status === 504) {
    return 'La operación tardó demasiado. Revisá la conexión y volvé a intentar. Si estabas guardando, verificá primero si el cambio se guardó.';
  }
  if (status >= 500) return `${fallback} El servidor o el almacenamiento no está disponible. Intentá nuevamente en unos minutos.`;
  if (!error.response && error.request) return 'No se pudo conectar con el servidor. Revisá tu conexión y volvé a intentar.';
  const data = error.response?.data;
  const detail = typeof data === 'object' && data ? messages(data).join(' · ') : '';
  return detail || fallback;
}

function firstMessage(value) {
  if (value == null || value === '') return ''
  if (Array.isArray(value)) return firstMessage(value[0])
  if (typeof value === 'object') {
    for (const nested of Object.values(value)) {
      const message = firstMessage(nested)
      if (message) return message
    }
    return ''
  }
  return String(value).trim()
}

function normalizePayload(errorOrData) {
  if (!errorOrData) return null
  if (errorOrData.response?.data) return errorOrData.response.data
  if (errorOrData instanceof Error) {
    if (typeof errorOrData.message === 'string' && errorOrData.message.trim()) {
      return { error: errorOrData.message.trim() }
    }
    return null
  }
  if (typeof errorOrData === 'string') return { error: errorOrData }
  if (typeof errorOrData === 'object') return errorOrData
  return null
}

export function extractApiErrorMessages(errorOrData, fallback = 'Ocurrió un error. Intentá de nuevo.') {
  const data = normalizePayload(errorOrData)
  if (!data) return [fallback]

  const messages = []
  const seen = new Set()
  const add = (value) => {
    const message = firstMessage(value)
    if (message && !seen.has(message)) {
      seen.add(message)
      messages.push(message)
    }
  }

  add(data.error)
  add(data.detail)
  add(data.message)
  add(data.non_field_errors)

  const skipKeys = new Set([
    'error',
    'detail',
    'message',
    'non_field_errors',
    'code',
    'retry_after_seconds',
  ])

  for (const [field, value] of Object.entries(data)) {
    if (skipKeys.has(field)) continue
    add(value)
  }

  return messages.length ? messages : [fallback]
}

export function extractApiErrorMessage(errorOrData, fallback = 'Ocurrió un error. Intentá de nuevo.') {
  return extractApiErrorMessages(errorOrData, fallback)[0]
}
